import { ThemeType } from "@itwin/itwinui-react";
import { editor } from "monaco-editor/esm/vs/editor/editor.api";
import { FilePath, SelectionRange } from "./SourceFiles";
import { CodeEditorInstance } from "../components/code-editor/CodeEditorInstance";

export type FocusMode = "none" | "selection" | "isolated" | "blurred" | "dimmed";

export const parseFocusModeString = (focusMode: string | undefined | null) => {
  switch (focusMode) {
    case "none":
    case "selection":
    case "isolated":
    case "blurred":
    case "dimmed":
      return focusMode as FocusMode;
    default:
      return undefined;
  }
};

export interface CodeEditorOptions {
  /** file path to display in editor, make sure it's create as editor model before */
  filePath?: string;

  /** monaco-editor theme */
  theme?: ThemeType;

  showMinimap?: boolean;

  showlineNumbers?: boolean;

  codeFolding?: boolean;

  /** preselect a range of lines in editor */
  selection?: SelectionRange;

  /** enable focus on a portion of file */
  focusMode?: FocusMode;

  /** Boolean specifying whether the editor can accept edits */
  readOnly?: boolean;

  /** indicates that typescript definitions are loading */
  tsInitializing?: boolean

  /** callback when editor is created, returns instance of editor object */
  onEditorMounted?: (editor?: CodeEditorInstance) => void;

  /** callack when type definition is opened */
  onDefinitionOpened?: (filePath: FilePath, selection?: SelectionRange) => void;
}

export interface CodeEditorViewState {
  [filePath: string]: editor.ICodeEditorViewState | null
}

export type CodeEditorStatus = "loading" | "checking" | undefined;
